import { combineReducers } from 'redux';
import { serverFlowSettingsSlice } from 'companyLocations/pages/serverFlow/redux/settings/slice';
import { readyPaymentsSlice } from 'companyLocations/pages/serverFlow/redux/readyPayments/slice';

export const serverFlowReducer = combineReducers({
  serverFlowConfig: serverFlowSettingsSlice.reducer,
  readyPayments: readyPaymentsSlice.reducer,
});
